import {
  IAdminOrganizationDetails,
  IAdminOrganizationEditPayload,
  IAdminOrganizationFormValues,
} from '@interfaces/adminOrganizations';

const accessKeyPlaceholder = '********';

export const convertAdminOrganizationDetailsIntoFormValues = (
  data: IAdminOrganizationDetails,
): IAdminOrganizationFormValues => ({
  programCodeId: data.programCodeId,
  name: data.name,
  accessCode: accessKeyPlaceholder,
  usesSports: data.usesSports,
  usesAthleteRoles: data.usesAthleteRoles,
  usesGender: data.usesGender,
  showMedicationExceptionLink: data.showMedicationExceptionLink,
  medicationExceptionFileName: data.medicationExceptionFileName,
  medicationExceptionFileUrl: data.medicationExceptionFileUrl,
  showRiskList: data.showRiskList,
});

export const convertFormValuesToEditPayload = (
  id: number,
  values: IAdminOrganizationFormValues,
): IAdminOrganizationEditPayload => ({
  id,
  accessCode: values.accessCode !== accessKeyPlaceholder ? values.accessCode : undefined,
  usesSports: values.usesSports,
  usesAthleteRoles: values.usesAthleteRoles,
  usesGender: values.usesGender,
  name: values.name,
  medicationExceptionFileName: values.medicationExceptionFileName,
  medicationExceptionFileUrl: values.medicationExceptionFileUrl,
  showMedicationExceptionLink: values.showMedicationExceptionLink,
  showRiskList: values.showRiskList,
});

export const validateForm = (values: IAdminOrganizationFormValues) => {
  const errors: Partial<Record<keyof IAdminOrganizationFormValues, string | boolean>> = {};

  if (!values.name) errors.name = true;
  if (!values.accessCode) errors.accessCode = true;
  if (values.showMedicationExceptionLink) {
    if (!values.medicationExceptionFileName) errors.medicationExceptionFileName = true;
    if (!values.medicationExceptionFileUrl) errors.medicationExceptionFileUrl = true;
  }

  return errors;
};
